import FieldSwitch from "../field-switch";
import React from "react";
import FieldsForm from "../fields-form";
import {classNames} from "../../../util/util-helpers";

export default function FieldGroupConditional({
                                                  switchFieldName,
                                                  fieldsState,
                                                  toggleFields,
                                                  translate,
                                                  formContainerGridClass = "grid col-span-1 gap-3.5",
                                                  className = "py-3.5 px-4 border border-tm-gray-200 rounded-card",
                                                  addClass,
                                                  selects,
                                                  onChange
                                              }) {
    const item = fieldsState?.[switchFieldName];
    const itemLabel = item?.metadata?.label ?? item?.name;
    const itemNote = item?.metadata?.note;
    return <div
        className={
            classNames(className, addClass)
        }
    >
        <div
            key={switchFieldName}
            className={"flex items-start min-w-0 flex-1 text-sm text-left"}
        >
            <div className="flex-1 min-w-0 pr-1 leading-4.5">
                <label htmlFor="person-3" className="font-semibold text-tm-gray-900 select-none">{itemLabel}</label>

                {!!itemNote && (
                    <p className="text-tm-gray-700 mt-0.5">{itemNote}</p>
                )}
            </div>

            <FieldSwitch
                {...item}
                {...item.props}
                label={itemLabel}
                onChange={onChange}
            />
        </div>

        {!!item.value && (
            <div className={
                classNames(
                    "border-t border-dashed border-tm-gray-300 mt-3.5 pt-3.5",
                    formContainerGridClass
                )
            }>
                <FieldsForm
                    fieldsState={fieldsState}
                    includeFields={toggleFields}
                    onChange={onChange}
                    selects={selects}
                    translate={translate}
                />
            </div>
        )}
    </div>
}